import getIndexOfNextAvailablePaymentOption from './getIndexOfNextAvailablePaymentOption';
import {getPaymentOptions} from './PaymentOptionSelectors';

export default (state) => {
  const indexOfNextAvailablePaymentOption = getIndexOfNextAvailablePaymentOption(state);
  const paymentOptions = getPaymentOptions(state);
  
  if (!paymentOptions?.length || paymentOptions.length <= 0) return false;
  
  return indexOfNextAvailablePaymentOption >= 0 && indexOfNextAvailablePaymentOption < paymentOptions.length;
};
